import { render, staticRenderFns } from "./base-header.vue?vue&type=template&id=76fea5c4&scoped=true&"
import script from "./base-header.vue?vue&type=script&lang=js&"
export * from "./base-header.vue?vue&type=script&lang=js&"
import style0 from "./base-header.vue?vue&type=style&index=0&id=76fea5c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fea5c4",
  null
  
)

export default component.exports